import type { Map } from "ol";
import { deviceIsMobile } from "../../../../../features/mobileTabletChecker";
import { transform } from "ol/proj";
import { store } from "../../../../../stateManagement/store";
import { setMapInfoMousePosition } from "../../../../../stateManagement/reducers/MapInfoSlice";

export function activateMonitorScaleInfo(mapInfoWidgetIsShown: boolean, map?: Map) {
    const onMobileScreenPointerMoveFunction = () => onMobileScreenPointerMove(map)
    const onBigScreenPointerMoveFunction = (event: any) => onBigScreenPointerMove(event, map)
    // Вывод строки с координатами при условии, что используется большая карта
    if (map) {
        // Вывод координат курсора на контент-бар
        if (mapInfoWidgetIsShown) {
            if (deviceIsMobile()) {
                map.on('pointerdrag', onMobileScreenPointerMoveFunction)
                map.on('moveend', onMobileScreenPointerMoveFunction)
            } else {
                map.on('pointermove', onBigScreenPointerMoveFunction)
            }
        }
        return {
            off: () => {
                map.un('pointerdrag', onMobileScreenPointerMoveFunction)
                map.un('moveend', onMobileScreenPointerMoveFunction)
                map.un('pointermove', onBigScreenPointerMoveFunction)
            }
        }
    }
}

function onBigScreenPointerMove(event: any, map?: Map) {
    const coordinates = event.coordinate;
    let adaptiveCoord = transform(coordinates, 'EPSG:3857', 'EPSG:4326')
    store.dispatch(setMapInfoMousePosition(adaptiveCoord))
}

function onMobileScreenPointerMove(map?: Map) {
    const coordinates: any = map?.getView().getCenter();
    let adaptiveCoord = transform(coordinates, 'EPSG:3857', 'EPSG:4326')
    store.dispatch(setMapInfoMousePosition(adaptiveCoord))
}